import { DateTime } from "luxon";
import React from "react";
import { useImmer } from "use-immer";

import {
  IgButton,
  IgTextField,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { OrganizationDto } from "@intelligems/ig-types";
import { InfoOutlined } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

import { usePatchOrganization } from "../../../api/organizations/patch-organization";

interface FreeTrialExtenderProps {
  organization: OrganizationDto;
}
export const FreeTrialExtender = ({ organization }: FreeTrialExtenderProps) => {
  const patchOrganization = usePatchOrganization();
  const [freeTrialValue, setFreeTrialValue] = useImmer<DateTime | null>(
    organization.freeTrialExpiresAtTs
      ? DateTime.fromMillis(organization.freeTrialExpiresAtTs)
      : null
  );

  const onFreeTrialSave = () => {
    if (freeTrialValue) {
      patchOrganization.mutate({
        body: {
          freeTrialExpiresAtTs: freeTrialValue
            .set({ hour: 23 })
            .set({ minute: 59 })
            .set({ second: 59 })
            .toMillis(),
        },
        queryParams: undefined,
        pathParams: undefined,
      });
    }
  };

  return (
    <Grid container item direction={"column"} rowSpacing={2}>
      <Grid item container alignItems={"center"}>
        <IgTypography sx={{ marginRight: "5px" }} variant={"h6"}>
          Free Trial Extender
        </IgTypography>
        <IgTooltip
          title={
            <IgTypography>
              The free trial will be set to the date selected around 11:59pm
            </IgTypography>
          }
        >
          <IconButton aria-label="info" size={"small"}>
            <InfoOutlined fontSize={"small"} />
          </IconButton>
        </IgTooltip>
      </Grid>
      <Grid item container direction={"row"} columnSpacing={2}>
        <Grid item>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <DatePicker
              onChange={(newValue) => {
                setFreeTrialValue(newValue);
              }}
              value={freeTrialValue}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item>
          <IgButton
            loading={patchOrganization.isPending}
            onClick={onFreeTrialSave}
            variant={"contained"}
            disabled={!freeTrialValue}
          >
            Save
          </IgButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
